module.exports = __webpack_public_path__ + "static/media/icon-twitter.5cf1dcad.svg";